<template>
  <nav class="panel">
    <p class="panel-heading">
      Repositories
    </p>
    <div class="panel-block">
      <p class="control has-icons-left">
        <input class="input is-small" type="text" placeholder="Search">
        <span class="icon is-small is-left">
          <i class="fa fa-search"></i>
        </span>
      </p>
    </div>
    <p class="panel-tabs">
      <a class="is-active">All</a>
      <a>Public</a>
      <a>Private</a>
      <a>Sources</a>
      <a>Forks</a>
    </p>
    <a class="panel-block is-active">
      <span class="panel-icon">
        <i class="fa fa-book"></i>
      </span>
      bulma
    </a>
    <a class="panel-block">
      <span class="panel-icon">
        <i class="fa fa-book"></i>
      </span>
      marksheet
    </a>
    <a class="panel-block">
      <span class="panel-icon">
        <i class="fa fa-book"></i>
      </span>
      minireset.css
    </a>
    <a class="panel-block">
      <span class="panel-icon">
        <i class="fa fa-book"></i>
      </span>
      jgthms.github.io
    </a>
    <a class="panel-block">
      <span class="panel-icon">
        <i class="fa fa-code-fork"></i>
      </span>
      daniellowtw/infBoard
    </a>
    <a class="panel-block">
      <span class="panel-icon">
        <i class="fa fa-code-fork"></i>
      </span>
      mojs
    </a>
    <label class="panel-block">
      <input type="checkbox">
      Remember me
    </label>
    <div class="panel-block">
      <button class="button is-primary is-outlined is-fullwidth">
        Reset all filters
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'zero-level-create',
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/west-slide-component/zero-level-create.vue